/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TokenObtain } from '../models/TokenObtain';
import type { TokenObtainResponse } from '../models/TokenObtainResponse';
import type { TokenRefresh } from '../models/TokenRefresh';
import type { TokenRefreshResponse } from '../models/TokenRefreshResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web
     * token pair to prove the authentication of those credentials.
     * @returns TokenObtainResponse
     * @throws ApiError
     */
    public authTokenCreate({
        requestBody,
    }: {
        requestBody: TokenObtain,
    }): CancelablePromise<TokenObtainResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/token/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web
     * token if the refresh token is valid.
     * @returns TokenRefreshResponse
     * @throws ApiError
     */
    public authTokenRefreshCreate({
        requestBody,
    }: {
        requestBody: TokenRefresh,
    }): CancelablePromise<TokenRefreshResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/token/refresh/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
